// Horário de atendimento da fila (tela Filas): fora dele, quem chama no WhatsApp recebe a resposta rápida escolhida.
import React, { useEffect, useState } from "react";
import {
  Checkbox, FormControlLabel, MenuItem, TextField, Typography,
} from "@material-ui/core";

import api from "../services/api";
import suporteApi from "./api";

const DIAS = [["seg", "Segunda"], ["ter", "Terça"], ["qua", "Quarta"], ["qui", "Quinta"], ["sex", "Sexta"],
  ["sab", "Sábado"], ["dom", "Domingo"]];

// todas as respostas rápidas (a API do Whaticket devolve 20 por página)
const listarRespostas = async () => {
  const todas = [];
  for (let pagina = 1; pagina <= 20; pagina += 1) {
    const { data } = await api.get("/quickAnswers", { params: { searchParam: "", pageNumber: pagina } });
    todas.push(...(data.quickAnswers || []));
    if (!data.hasMore) break;
  }
  return todas;
};

export const carregarExpediente = (filaId) => suporteApi.get(`/api/filas/${filaId}/expediente`).then((r) => r.data);
export const salvarExpediente = (filaId, e) => suporteApi.put(`/api/filas/${filaId}/expediente`, e).then((r) => r.data);

const ExpedienteFila = ({ valor, onChange }) => {
  const [respostas, setRespostas] = useState([]);
  useEffect(() => { listarRespostas().then(setRespostas).catch(() => setRespostas([])); }, []);
  if (!valor) return null;
  const dia = (d, campo, v) => onChange({ ...valor, dias: { ...valor.dias, [d]: { ...valor.dias[d], [campo]: v } } });
  return (
    <div style={{ marginTop: 16 }}>
      <FormControlLabel
        control={<Checkbox color="primary" checked={!!valor.ativo} onChange={(e) => onChange({ ...valor, ativo: e.target.checked })} />}
        label={<b>Horário de atendimento (mensagem automática fora do horário)</b>} />
      {valor.ativo && (
        <>
          <Typography variant="caption" color="textSecondary" component="div" style={{ marginBottom: 8 }}>
            Fora do horário, quem chamar no WhatsApp recebe a resposta rápida abaixo: uma vez por conversa a cada
            {` ${valor.intervalo_horas} h`}, e não se um atendente estiver respondendo essa conversa na última hora.
          </Typography>
          {DIAS.map(([d, nome]) => {
            const v = valor.dias[d] || {};
            return (
              <div key={d} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FormControlLabel style={{ width: 130, margin: 0 }} label={nome}
                  control={<Checkbox size="small" color="primary" checked={!!v.aberto} onChange={(e) => dia(d, "aberto", e.target.checked)} />} />
                {v.aberto ? (
                  <>
                    <TextField type="time" size="small" variant="outlined" margin="dense" value={v.inicio || ""}
                      onChange={(e) => dia(d, "inicio", e.target.value)} inputProps={{ "aria-label": `${nome} início` }} />
                    <span>às</span>
                    <TextField type="time" size="small" variant="outlined" margin="dense" value={v.fim || ""}
                      onChange={(e) => dia(d, "fim", e.target.value)} inputProps={{ "aria-label": `${nome} fim` }} />
                  </>
                ) : <Typography variant="body2" color="textSecondary">fechado</Typography>}
              </div>
            );
          })}
          <TextField select fullWidth size="small" variant="outlined" margin="dense" label="Resposta rápida enviada fora do horário"
            value={valor.resposta_rapida_id || ""} onChange={(e) => onChange({ ...valor, resposta_rapida_id: e.target.value || null })}
            style={{ marginTop: 12 }}>
            {respostas.map((q) => <MenuItem key={q.id} value={q.id}>{q.shortcut}</MenuItem>)}
          </TextField>
          {valor.resposta_rapida_id && (
            <Typography variant="body2" style={{ whiteSpace: "pre-wrap", background: "rgba(0,0,0,.04)", padding: 8, borderRadius: 6 }}>
              {respostas.find((q) => q.id === valor.resposta_rapida_id)?.message || ""}
            </Typography>
          )}
          <TextField type="number" size="small" variant="outlined" margin="dense" label="Repetir no máximo a cada (horas)"
            value={valor.intervalo_horas} inputProps={{ min: 1, max: 72 }}
            onChange={(e) => onChange({ ...valor, intervalo_horas: Number(e.target.value) || 12 })} />
        </>
      )}
    </div>
  );
};

export default ExpedienteFila;
